<template>
  <div class="background-modal">
    <div class="wrapper-modal">
      <div class="close-button">
        <img
          src="assets/administrator/Close.svg"
          alt="close"
          class="icon"
          @click="closeModal"
        />
      </div>
      <div class="wrapper-details">
        <div class="wrapper-file">
          <img src="assets/corporate/Image1.png" alt="preview" class="file" />
          <!-- <video
            class="file"
            controls
            controlsList="nodownload noplaybackrate "
            disablePictureInPicture
          >
            <source
              src="assets/corporate/EmpresarialVideo1.mp4"
              type="video/mp4"
            />
          </video> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ModalPreviewFile",
  components: {},
  setup(props, context) {
    function closeModal() {
      context.emit("close");
    }

    return {
      closeModal,
    };
  },
});
</script>

<style scoped lang="scss">
@import "src/ux/admin/createEditDelivery/styles/modalPreviewFileStyle";
</style>
